import { Portfolio, Site } from "../../features/sites/sites.module";
import { formatStringDate } from "../utils/dateUtils";

export const formatCoordinates = (
	decimals: number,
	site: Site
): { latitude: string; longitude: string } => {
	const latitude = site?.coordinates?.DECIMAL?.latitude
		? parseFloat(site?.coordinates?.DECIMAL?.latitude).toFixed(decimals)
		: (site.latitude || 0).toFixed(decimals);
	const longitude = site?.coordinates?.DECIMAL?.longitude
		? parseFloat(site?.coordinates?.DECIMAL?.longitude).toFixed(decimals)
		: (site.longitude || 0).toFixed(decimals);
	return { latitude, longitude };
};

export const makeLatLongColumn = (
	latitudeAccessor: (site: Site | Portfolio) => string,
	longitudeAccessor: (site: Site | Portfolio) => string
) => {
	return [
		{
			id: "latitude",
			header: () => "Latitude",
			xs: 1,
			accessor: latitudeAccessor,
			sortable: true,
		},
		{
			id: "longitude",
			header: () => "Longitude",
			xs: 1,
			accessor: longitudeAccessor,
			sortable: true,
		},
	];
};

export const formatDateWithTimezone = (
	date: string | undefined,
	format: string = "yyyy-MM-dd HH:mm"
) => {
	const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
	if (date) return formatStringDate(date, format, timezone);
	return "";
};
